/**
 * Constants for marker rendering and positioning
 */

// Icon sizes and dimensions
export const DEFAULT_ICON_SIZE = 24;
export const FALLBACK_ICON_SIZE = 24;
export const FALLBACK_ICON_FONT_SIZE = 14;

// Positioning offsets
export const INFOPANE_HORIZONTAL_ADJUSTMENT = 1;
export const DEFAULT_INFOPANE_OFFSET_Y = 40;
export const INFOPANE_EDGE_BUFFER = 20; // Min distance from map edges
/**
 * Arrow wrapper dimensions in pixels.
 * IMPORTANT: Keep in sync with --arrow-size CSS custom property (2.7rem) in TTMarker.module.scss
 * At default 10px root font size: 2.7rem = 27px
 */
export const INFOPANE_ARROW_SIZE = 27;
export const INFOPANE_ARROW_PADDING = 8; // Min padding from InfoPane edges
export const INFOPANE_FALLBACK_WIDTH = 400; // Fallback width when DOM measurement unavailable
export const INFOPANE_FALLBACK_HEIGHT = 200; // Fallback height when DOM measurement unavailable

// Timing constants
export const PLANT_MARKER_HOVER_DELAY = 220;
export const DOM_UPDATE_TIMEOUT = 0;

// Precision tolerances
export const POSITION_CHANGE_TOLERANCE = 0.000001; // ~1 meter precision for lat/lng comparison

// Z-index layering constants
// CRITICAL: InfoPanes must always appear above description labels/markers
// The z-index hierarchy ensures proper visual stacking:
// 1. Pin markers (1000+) - Special markers that must be on top of everything
// 2. InfoPanes (500-999) - Selected marker information panels
// 3. Labels/Markers (1-499) - Unselected markers and their description labels
export const Z_INDEX_PIN_MARKER = 1000; // Special pin markers (always on top)
export const Z_INDEX_PIN_MARKER_DEFAULT = 300;
export const Z_INDEX_INFOPANE_TOP = 500; // Last selected infopanel (must be above all labels)
export const Z_INDEX_INFOPANE_MIDDLE = 450; // Other open infopanels
export const Z_INDEX_MARKER_TOP = 100; // Last selected marker (without InfoPane)
export const Z_INDEX_MARKER_MIDDLE = 50; // Other selected markers
export const Z_INDEX_MARKER_BOTTOM = 10; // Unselected markers and description labels

// Shadow filter values
export const SHADOW_OPACITY_STRONG = 0.8;
export const SHADOW_OPACITY_MEDIUM = 0.6;
export const SHADOW_OPACITY_LIGHT = 0.4;
export const SELECTION_HIGHLIGHT_OPACITY = 0.9;

// Colors
export const FALLBACK_ICON_BACKGROUND = '#666';
export const FALLBACK_ICON_TEXT_COLOR = 'white';
export const DEFAULT_FILL_COLOR = '#000000';
export const DEFAULT_STROKE_COLOR = 'none';
export const SELECTION_HIGHLIGHT_COLOR = 'rgba(58, 142, 236, 0.9)';

// CSS values
export const FULL_BORDER_RADIUS = '50%';
export const BLOCK_DISPLAY = 'block';
export const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';

// Shadow filter definitions
export const EXTERNAL_SHADOW_FILTERS = [
  `drop-shadow(0 0 1px rgba(0, 0, 0, ${SHADOW_OPACITY_STRONG}))`,
  `drop-shadow(0 0 2px rgba(0, 0, 0, ${SHADOW_OPACITY_MEDIUM}))`,
  `drop-shadow(0 0 3px rgba(0, 0, 0, ${SHADOW_OPACITY_LIGHT}))`,
];

export const INTERNAL_SHADOW_FILTERS = [
  'drop-shadow(0 0 1px rgba(0, 0, 0, 0))',
  'drop-shadow(0 0 2px rgba(0, 0, 0, 0))',
  'drop-shadow(0 0 3px rgba(0, 0, 0, 0))',
];

export const SELECTION_HIGHLIGHT_FILTER = `drop-shadow(0 0 2px ${SELECTION_HIGHLIGHT_COLOR})`;
